import React, { useState, useEffect } from "react";
import { useBottomScrollListener } from "react-bottom-scroll-listener";
import { useNavigate  } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Modal, Spinner } from "react-bootstrap";
import { getChildFacilities } from "../actions";
import Maintenance from "../../Maintenance";

/*** 
@purpose : Functional Component
@Parameter : {props}
**/
function ChildFacilities(props) {
  const navigate = useNavigate();
  const [lang] = useTranslation("language");
  const [customerNotFound, setCustomerNotFound] = useState();
  const [details, setDetails] = useState([]);
  const [data, setData] = useState({});
  const [limit, setLimit] = useState(40);
  const [loading, setLoading] = useState(true);
  const [lazyLoading, setLazyLoading] = useState(false);
  const [maintenance, setMaintenance] = useState(false);
  const [orgId, setOrgId] = useState();
  const [total, setTotal] = useState(0);

  const [manl, setMANL] = useState("asc");
  const [ucc, setUCC] = useState("asc");

  const routes = [
    {
      name: `${lang("Menu.home")}`,
      path: "/",
    },
    {
      name: `${lang("Menu.organizationCustomer")}`,
      path: "/organizationCustomer",
    },
    {
      name: `${lang("organizationDetails.organizationCustomerDetails")}`,
      path: "",
    },
  ];

  useEffect(() => {
    async function fetchChildFacilities() {
      try {
        setOrgId(props.id);
        let body = {
          id: props.id,
          limit: 0,
          totalRecords: 0,
        };
        const res = await getChildFacilities(body);
        
        // if (res.maintenanceWindowFlag) {
        //   setMaintenance(true);
        // } else {
        setDetails(
          res && res.data && res.data.childFacility && res.data.childFacility
        );
        setTotal(
          res && res.data.childFacility && res.data.childFacility[0].total
        );
        // }
      } catch (error) {
        console.error("Error fetching child facilities:", error);
      } finally {
        setLoading(false);
      }
    }
    
    fetchChildFacilities();
  }, []);

  /*** 
  @purpose : Change Route
  @Parameter : {e, page}
  **/
  const changeRoute = (e, page) => {
    e.stopPropagation();
    e.nativeEvent.stopImmediatePropagation();
    navigate(page);
    window.location.reload();
  };

  /***
  @purpose : Lazyload function
  @Parameter : {}
  **/
  // const handleContainerOnBottom = async () => {
  //   console.log("child");
  //   setLazyLoading(true);

  //   let body = {
  //     id: orgId,
  //     limit: details.length,
  //     totalRecords: total,
  //   };
  //   setLazyLoading(false);
  //   if (details.length <= total && total >= 30) {
  //     console.log("inside child");
  //     await getChildFacilities(body).then((response) => {
  //       let list = [];
  //       list = details.concat(response.data.childFacility);
  //       setDetails(list);
  //     });
  //     setLimit(limit + 10);
  //   }
  // };

  const loadRecords = async () => {
    if (details.length < total) {
      try {
        setLazyLoading(true);
        let body = {
          id: orgId,
          limit: details.length,
          totalRecords: total,
        };
        
        const response = await getChildFacilities(body);
        let list = details.concat(response.data.childFacility);
        setDetails(list);
        setLimit(limit + 100);
      } catch (error) {
        console.error("Error loading more records:", error);
      } finally {
        setLazyLoading(false);
      }
    }
  };

  // const containerRef = useBottomScrollListener(handleContainerOnBottom);


  /*** 
@purpose : Handle sorting
@Parameter : {}
**/
  const handleSortingData = (obj) => {
    obj.column === "marketAuthorizationNameLocal" && setMANL(obj.sortOrder);
    obj.column === "unifiedCustomerCode" && setUCC(obj.sortOrder);
    let list = compareBySortedData(obj);
    setDetails(list);
  };

  /*** 
  @purpose : Compare sorted data
  @Parameter : {}
  **/
  const compareBySortedData = (obj) => {
    const sorted = details.sort((a, b) => {
      const isReversed = obj.sortOrder === "asc" ? 1 : -1;
      let first = a[obj.column] ? a[obj.column] : "";
      let second = b[obj.column] ? b[obj.column] : "";
      return isReversed * first.localeCompare(second);
    });
    return sorted;
  };


  return (
    <>
      {loading ? (
        <Spinner animation="border" />
      ) : (
        <>
          <div className="org-main">
            <div className="org-wrapper1">
              <h4 className="primary-title">
                {lang("OrganizationMenu.childFacilities")}
              </h4>
              {details && details.length > 0 && (
                <p className="record-total">
                  {lang("territoryDefinitionMaintenance.totalRecords")} -{" "}
                  {details && details.length} / {total}
                </p>
              )}
              {details && details.length > 0 && (
                <>
                  <div
                    // ref={containerRef}
                    className="table-responsive mb-0 max-height hover-table"
                  // onBottom={handleContainerOnBottom}
                  >
                    <table className="table" aria-describedby="table">
                      <thead>
                        <tr>
                          <th scope="col"
                            onClick={() =>
                              handleSortingData({
                                column: "marketAuthorizationNameLocal",
                                sortOrder: manl === "desc" ? "asc" : "desc",
                              })
                            }
                          >
                            <div className="cursor-pointer">
                              {lang("organizationDetails.product")}
                              <em className="bx bxs-sort-alt"></em>
                            </div>
                          </th>
                          <th scope="col"
                            onClick={() =>
                              handleSortingData({
                                column: "unifiedCustomerCode",
                                sortOrder: ucc === "desc" ? "asc" : "desc",
                              })
                            }
                          >
                            <div className="cursor-pointer">
                              {lang("organizationDetails.childFacility")}
                              <em className="bx bxs-sort-alt"></em>
                            </div>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {details &&
                          details.map((org, index) => {
                            return (
                              org && (
                                <tr
                                  key={index}
                                  onClick={(e) =>
                                    changeRoute(
                                      e,
                                      `/organizationInfo?orgId=${org.ID}`
                                    )
                                  }
                                >
                                  <td>
                                    {org && org.marketAuthorizationNameLocal
                                      ? org.marketAuthorizationNameLocal
                                      : ""}
                                  </td>
                                  <td>
                                    {/* (org && org.legacyUnifiedCustomerCode   /* SAKAMOTO: AHDD-5861 Ultmarc code change */
                                     /* ? org.legacyUnifiedCustomerCode         /* SAKAMOTO: AHDD-5861 Ultmarc code change */}
                                    {(org && org.unifiedCustomerCode            /* SAKAMOTO: AHDD-5861 Ultmarc code change */
                                      ? org.unifiedCustomerCode                 /* SAKAMOTO: AHDD-5861 Ultmarc code change */
                                      : "") +
                                      " " +
                                      (org.customerNameLocalAbbr
                                        ? org.customerNameLocalAbbr
                                        : "")}
                                  </td>
                                </tr>
                              )
                            );
                          })}
                      </tbody>
                    </table>
                  </div>
                  {details.length < total && (
                    <div className="steps-action1 mt-4">
                      {lazyLoading && <Spinner animation="border" />}
                      <button
                        className="btn btn-primary"
                        onClick={loadRecords}
                        disabled={lazyLoading}
                      >
                        {lang("Buttons.loadMore")}
                      </button>
                    </div>
                  )}
                </>
              )}
            </div>
          </div>
          <Modal
            size="md"
            className="withdraw-modal"
            show={customerNotFound}
            aria-labelledby="contained-modal-title-vcenter"
            centered
          >
            <Modal.Body>
              <div className="warning-msg">
                <img src="images/warning2.svg" alt="Warning" /> Customer Not
                Found
              </div>
              <p className="mb-3">
                {lang("errorMessages.SEARCH_CUSTOMERS")}
                <a
                  className="link"
                  onClick={(e) => {
                    changeRoute(e, "/organizationCustomer");
                  }}
                >
                  {lang("Menu.organizationCustomer")}
                </a>
              </p>
            </Modal.Body>
          </Modal>
        </>
      )}
    </>
  );
}

export default ChildFacilities;
